import React from 'react';
import { Play, Mail, Phone, MapPin, Instagram, Linkedin, ArrowDown, Camera, Film, Palette, Sparkles } from 'lucide-react';

export default function VideoProducerPortfolio() {
  const [isMobile, setIsMobile] = React.useState(false);
  const [showImprint, setShowImprint] = React.useState(false);
  const [showPrivacy, setShowPrivacy] = React.useState(false);
  const [logoSpinning, setLogoSpinning] = React.useState(false);
  const [expandedPhoto, setExpandedPhoto] = React.useState(null);
const [expandedVideo, setExpandedVideo] = React.useState(null);


  // ========== EDIT YOUR VIDEO URLS HERE ==========
  const SHOWREEL_URL = '';
  const TECH_VIDEO_URL = 'https://youtube.com/shorts/XNniwFMZ9B4';
  // ===============================================

  // ========== EDIT YOUR CLIENT LOGOS HERE ==========
  const CLIENT_LOGOS = [
    { name: 'Client 1', logo: 'https://i.imgur.com/hSyBDwE.png' },
    { name: 'Client 2', logo: 'https://i.imgur.com/3kyyjlA.png' },
    { name: 'Client 3', logo: 'https://i.imgur.com/E6Cg791.png' },
    { name: 'Client 4', logo: 'https://i.imgur.com/YO3ZPag.png' },
    { name: 'Client 5', logo: 'https://i.imgur.com/8Mx0K6o.png' },
    { name: 'Client 6', logo: 'https://i.imgur.com/SwIMKw6.png' },
    { name: 'Client 7', logo: 'https://i.imgur.com/93TBqcH.png' },
    { name: 'Client 8', logo: 'https://i.imgur.com/8MSem73.png' },
    { name: 'Client 9', logo: 'https://i.imgur.com/ydLfhY9.png' },
    { name: 'Client 10', logo: 'https://i.imgur.com/fmKdHMP.png' },
    { name: 'Client 11', logo: 'https://i.imgur.com/SehFIy8.png' },
    { name: 'Client 12', logo: 'https://i.imgur.com/9K20UAb.png' },
    { name: 'Client 13', logo: 'https://i.imgur.com/VFc1d3k.png' },
    { name: 'Client 14', logo: 'https://i.imgur.com/3OVHfCy.png' },
    { name: 'Client 15', logo: 'https://i.imgur.com/dc2UJgH.png' },
    { name: 'Client 16', logo: 'https://i.imgur.com/GXJuRxS.png' },
  ];
  // ===============================================

  // ========== EDIT YOUR WORK PHOTOS HERE ==========
const WORK_PHOTOS = [
  { src: 'https://i.imgur.com/WHnGSAu.jpeg', alt: 'Behind camera' },
  { src: 'https://i.imgur.com/vZpLLPb.jpeg', alt: 'Editing' },
  { src: 'https://i.imgur.com/hsK5W3c.jpeg', alt: 'On location' },
];
  // ===============================================

  // ========== EDIT YOUR WORK VIDEOS HERE ==========
  const WORK_VIDEOS = [
    { src: 'https://i.imgur.com/nb4ZEcR.mp4', alt: 'Video 1' },
    { src: 'https://i.imgur.com/u6YGMTa.mp4', alt: 'Video 2' },
    { src: 'https://i.imgur.com/RgdZvvH.mp4', alt: 'Video 3' },
    { src: 'https://i.imgur.com/2x4R9FA.mp4', alt: 'Video 4' },
    { src: 'https://i.imgur.com/841zOWC.mp4', alt: 'Video 5' },
  ];
  // ===============================================

  React.useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,500;0,600;1,400;1,500&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const services = [
    { icon: Film, title: "Video Production", description: "From concept to finished film – I guide your project through all phases of production." },
    { icon: Camera, title: "Camera Work", description: "Professional recordings with cutting-edge technology for your events, interviews, or corporate films." },
    { icon: Palette, title: "Post Production", description: "Editing, color grading, and sound design – I give your material the final polish." },
    { icon: Sparkles, title: "AI-Powered Workflow", description: "Leveraging the latest AI tools and software to deliver faster, smarter, and more creative results." }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  const handleLogoHover = () => {
    if (!logoSpinning) {
      setLogoSpinning(true);
      setTimeout(() => setLogoSpinning(false), 300);
    }
  };

  const renderVideo = (url) => {
    if (!url) return null;
    if (url.includes('youtube.com') || url.includes('youtu.be')) {
      const videoId = url.includes('watch?v=') ? url.split('watch?v=')[1].split('&')[0]
        : url.includes('youtu.be/') ? url.split('youtu.be/')[1].split('?')[0]
        : url.includes('shorts/') ? url.split('shorts/')[1].split('?')[0] : '';
      return <iframe title="Showreel" src={`https://www.youtube.com/embed/${videoId}`} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 'none' }} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />;
    } else if (url.includes('vimeo.com')) {
      const vimeoId = url.split('vimeo.com/')[1]?.split('?')[0];
      return <iframe title="Showreel" src={`https://player.vimeo.com/video/${vimeoId}`} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 'none' }} allow="autoplay; fullscreen; picture-in-picture" allowFullScreen />;
    }
    return null;
  };

  const renderTechVideo = (url) => {
    if (!url) return null;
    if (url.includes('youtube.com') || url.includes('youtu.be')) {
      const videoId = url.includes('watch?v=') ? url.split('watch?v=')[1].split('&')[0]
        : url.includes('youtu.be/') ? url.split('youtu.be/')[1].split('?')[0]
        : url.includes('shorts/') ? url.split('shorts/')[1].split('?')[0] : '';
      return <iframe title="Tech Video" src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1`} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 'none', pointerEvents: 'none' }} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" />;
    } else if (url.includes('vimeo.com')) {
      const vimeoId = url.split('vimeo.com/')[1]?.split('?')[0];
      return <iframe title="Tech Video" src={`https://player.vimeo.com/video/${vimeoId}?autoplay=1&muted=1&loop=1&background=1`} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 'none', pointerEvents: 'none' }} allow="autoplay; fullscreen; picture-in-picture" />;
    }
    return null;
  };

  return (
    <div className="main-container">
      
      {/* CSS-animated Blobs */}
      <div className="blob-container">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="blob blob-3"></div>
        <div className="blob blob-4"></div>
        <div className="blob blob-5"></div>
        <div className="blob blob-6"></div>
        <div className="blob blob-7"></div>
        <div className="blob blob-8"></div>
        <div className="blob blob-9"></div>
        <div className="blob blob-10"></div>
        <div className="blob blob-11"></div>
        <div className="blob blob-12"></div>
      </div>

      {/* Hero */}
      <section className="hero-section">
        <div className="hero-content">
          <img 
            src="https://i.imgur.com/GUdjMbp.png" 
            alt="Logo" 
	with="200px"
            className={`hero-logo-img ${logoSpinning ? 'spinning' : ''}`}
            onMouseEnter={handleLogoHover}
          />
          <h1 className="hero-name">ONUR CINAR</h1>
          <h2 className="hero-subtitle"><span className="title-gradient">Visual Storyteller</span></h2>
          <div className="hero-divider" />
          <p className="hero-headline">Your competitors are on screen.<br /><span className="headline-emphasis">Where are you?</span></p>
          <p className="hero-text">Video production for brands ready to stand out.</p>
          <div className="hero-buttons">
            <button onClick={() => scrollToSection('kontakt')} className="btn-primary">Request Project</button>
          </div>
        </div>
        <div className="scroll-indicator"><ArrowDown className="arrow-icon" /></div>
      </section>

      {/* About */}
      <section id="about" className="section">
        <div className="container">
          <div className={isMobile ? "grid-mobile" : "grid-2col-about"}>
            <div>
              <span className="label">About Me</span>
              <h2 className="heading">Creativity meets<span className="gradient-text"> Craftsmanship</span></h2>
              <p className="text-body">As a video producer from Cologne, I combine technical expertise with creative storytelling. Every project is unique – and deserves a tailor-made visual execution.</p>
              <p className="text-body">From the first idea to the finished film, I guide you through the entire production process. My goal: to tell your story authentically and impressively.</p>
            </div>
            <div className="profile-wrapper">
              <div className="profile-card">
                <img src="https://i.imgur.com/lRaZWnv.jpeg" alt="Profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <div className="profile-border" />
            </div>
          </div>
        </div>
      </section>

      {/* Video Showreel */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="label">Showreel</span>
            <h2 className="heading">See my <span className="gradient-text">work</span></h2>
          </div>
          <div className="video-wrapper">
            <div className="video-card">
              {SHOWREEL_URL ? renderVideo(SHOWREEL_URL) : (
                <div className="video-placeholder">
                  <div className="play-button"><Play className="play-icon" /></div>
                  <span className="placeholder-text">Showreel coming soon</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section id="services" className="section">
        <div className="container">
          <div className="section-header">
            <span className="label">Services</span>
            <h2 className="heading">What I can <span className="gradient-text">do</span> for you</h2>
          </div>
          <div className={isMobile ? "services-layout-mobile" : "services-layout"}>
            <div className="services-grid">
              {services.map((s, i) => {
                const IconComponent = s.icon;
                return (
                  <div key={i} className="service-card">
                    <div className="service-icon"><IconComponent style={{ width: '24px', height: '24px', color: '#991B1B' }} /></div>
                    <div className="service-content">
                      <h3 className="service-title">{s.title}</h3>
                      <p className="service-desc">{s.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="tech-video-container">
              <div className="tech-video-card">
                {TECH_VIDEO_URL ? renderTechVideo(TECH_VIDEO_URL) : (
                  <div className="video-placeholder">
                    <div className="play-button" style={{ width: '60px', height: '60px' }}>
                      <Camera style={{ width: '24px', height: '24px', color: '#991B1B' }} />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trusted By / Client Logos + Work Photos + Videos */}
      <section className="section clients-section">
        <div className="container">
          <div className="section-header">
            <span className="label">Trusted By</span>
            <h2 className="heading">Brands I've <span className="gradient-text">worked</span> with</h2>
          </div>
          
          {/* Floating Logos */}
          <div className="clients-floating">
            {CLIENT_LOGOS.map((client, i) => (
              <img 
                key={i} 
                src={client.logo} 
                alt={client.name} 
                className="floating-logo"
                style={{ animationDelay: `${i * 0.2}s` }}
              />
            ))}
          </div>

          {/* Work Photos Collage - FIRST */}
          <div className="work-collage photos-collage">
            {WORK_PHOTOS.map((photo, i) => (
              <div 
                key={i} 
                className={`collage-photo collage-photo-${i + 1} ${expandedPhoto === i ? 'expanded' : ''}`}
                onClick={() => setExpandedPhoto(expandedPhoto === i ? null : i)}
              >
                <img src={photo.src} alt={photo.alt} />
              </div>
            ))}
          </div>

        {/* Work Videos Collage - SECOND */}
<div className="work-collage video-collage">
  {WORK_VIDEOS.map((video, i) => (
    <div 
      key={i} 
      className={`collage-photo collage-video-${i + 1} ${expandedVideo === i ? 'expanded' : ''}`}
      onClick={() => setExpandedVideo(expandedVideo === i ? null : i)}
    >
                <video 
                  src={video.src} 
                  autoPlay 
                  muted 
                  loop 
                  playsInline
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="kontakt" className="section">
        <div className="container">
          <div className="section-header">
            <span className="label">Contact</span>
            <h2 className="heading">Let's <span className="gradient-text">talk</span></h2>
            <p className="text-body" style={{ maxWidth: '576px', margin: '0 auto' }}>Have a project in mind? I look forward to bringing your vision to life.</p>
          </div>
          <div className={isMobile ? "grid-mobile" : "grid-3col"}>
            <a href="mailto:me@onurcinar.de" className="contact-card">
              <div className="contact-icon"><Mail style={{ width: '24px', height: '24px', color: '#991B1B' }} /></div>
              <span className="contact-label">Email</span>
              <span className="contact-value">me@onurcinar.de</span>
            </a>
            <a href="tel:+491631353656" className="contact-card">
              <div className="contact-icon"><Phone style={{ width: '24px', height: '24px', color: '#991B1B' }} /></div>
              <span className="contact-label">Phone</span>
              <span className="contact-value">+49 163 1353656</span>
            </a>
            <div className="contact-card" style={{ cursor: 'default' }}>
              <div className="contact-icon"><MapPin style={{ width: '24px', height: '24px', color: '#991B1B' }} /></div>
              <span className="contact-label">Location</span>
              <span className="contact-value">Köln, Germany</span>
            </div>
          </div>
          <div className="social-links">
            <a href="https://www.instagram.com/onurcinar?igsh=bnd0ajI5dm55NGdz&utm_source=qr/" target="_blank" rel="noopener noreferrer" className="social-link"><Instagram style={{ width: '20px', height: '20px' }} /></a>
            <a href="https://www.linkedin.com/in/onur-cinar-a44675225?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" target="_blank" rel="noopener noreferrer" className="social-link"><Linkedin style={{ width: '20px', height: '20px' }} /></a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-text">© {new Date().getFullYear()} Onur Cinar · Video Producer · Köln</div>
            <div className="footer-links">
              <button onClick={() => setShowImprint(true)} className="footer-link">Impressum</button>
              <button onClick={() => setShowPrivacy(true)} className="footer-link">Privacy</button>
            </div>
          </div>
        </div>
      </footer>

      {showImprint && (
        <div className="modal-overlay" onClick={() => setShowImprint(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowImprint(false)}>×</button>
            <h2 className="modal-title">Impressum</h2>
            <div className="modal-body">
              <h3>Angaben gemäß § 5 TMG</h3>
              <p>
                Onur Cinar<br />
                Video Producer<br />
                {"Bonn" + "er Str" + "aße 52" + "8a"}<br />
                {"509" + "68"} Köln
              </p>
              <h3>Kontakt</h3>
              <p>
                Telefon: {"+49 " + "163 " + "135" + "3656"}<br />
                E-Mail: {"me" + "@" + "onur" + "cinar" + ".de"}
              </p>
              <h3>Umsatzsteuer-ID</h3>
              <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />{"DE" + "353" + "903" + "970"}</p>
              <h3>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
              <p>
                Onur Cinar<br />
                {"Bonn" + "er Str" + "aße 52" + "8a"}<br />
                {"509" + "68"} Köln
              </p>
              <h3>EU-Streitschlichtung</h3>
              <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr/. Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
              <h3>Haftung für Inhalte</h3>
              <p>Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
              <h3>Haftung für Links</h3>
              <p>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.</p>
            </div>
          </div>
        </div>
      )}

      {showPrivacy && (
        <div className="modal-overlay" onClick={() => setShowPrivacy(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowPrivacy(false)}>×</button>
            <h2 className="modal-title">Datenschutzerklärung</h2>
            <div className="modal-body">
              <h3>1. Datenschutz auf einen Blick</h3>
              <p><strong>Allgemeine Hinweise:</strong> Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen.</p>
              
              <h3>2. Hosting</h3>
              <p>Diese Website wird bei Vercel Inc., 340 S Lemon Ave #4133, Walnut, CA 91789, USA gehostet. Wenn Sie diese Website besuchen, werden automatisch technische Informationen (z.B. IP-Adresse, Browsertyp) erfasst. Diese Daten werden zur Bereitstellung der Website benötigt. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.</p>
              
              <h3>3. Verantwortliche Stelle</h3>
              <p>
                Onur Cinar<br />
                {"Bonn" + "er Str" + "aße 52" + "8a"}<br />
                {"509" + "68"} Köln<br />
                E-Mail: {"me" + "@" + "onur" + "cinar" + ".de"}
              </p>
              
              <h3>4. Externe Dienste</h3>
              <p><strong>Google Fonts:</strong> Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten sogenannte Google Fonts, die von Google LLC bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr Browser die benötigten Fonts in Ihren Browsercache. Dabei wird Ihre IP-Adresse an Server von Google übermittelt. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.</p>
              
              <h3>5. Ihre Rechte</h3>
              <p>Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger sowie den Zweck der Datenverarbeitung. Sie haben außerdem ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten.</p>
              
              <h3>6. SSL-Verschlüsselung</h3>
              <p>Diese Seite nutzt aus Sicherheitsgründen eine SSL-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von "http://" auf "https://" wechselt.</p>
            </div>
          </div>
        </div>
      )}

      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        html { scroll-behavior: smooth; }

        .main-container {
          font-family: 'Inter', sans-serif;
          background-color: #0A0A0A;
          color: white;
          min-height: 100vh;
          position: relative;
          overflow-x: hidden;
        }

        .blob-container {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: 0;
          overflow: hidden;
        }

        .blob {
          position: absolute;
          border-radius: 50%;
          pointer-events: none;
        }

        .blob-1 {
          width: 900px;
          height: 900px;
          left: -10%;
          top: 5%;
          background: radial-gradient(circle, rgba(153, 27, 27, 0.4) 0%, transparent 70%);
          filter: blur(80px);
          animation: float1 25s ease-in-out infinite;
        }

        .blob-2 {
          width: 750px;
          height: 750px;
          right: -5%;
          top: 40%;
          background: radial-gradient(circle, rgba(127, 29, 29, 0.35) 0%, transparent 70%);
          filter: blur(90px);
          animation: float2 30s ease-in-out infinite;
        }

        .blob-3 {
          width: 500px;
          height: 500px;
          left: 60%;
          top: 10%;
          background: radial-gradient(circle, rgba(185, 28, 28, 0.45) 0%, transparent 70%);
          filter: blur(60px);
          animation: float3 20s ease-in-out infinite;
        }

        .blob-4 {
          width: 450px;
          height: 450px;
          left: 5%;
          top: 60%;
          background: radial-gradient(circle, rgba(109, 40, 217, 0.3) 0%, transparent 70%);
          filter: blur(70px);
          animation: float4 22s ease-in-out infinite;
        }

        .blob-5 {
          width: 300px;
          height: 300px;
          left: 40%;
          top: 30%;
          background: radial-gradient(circle, rgba(153, 27, 27, 0.5) 0%, transparent 70%);
          filter: blur(50px);
          animation: float5 18s ease-in-out infinite;
        }

        .blob-6 {
          width: 280px;
          height: 280px;
          right: 15%;
          top: 70%;
          background: radial-gradient(circle, rgba(139, 92, 246, 0.35) 0%, transparent 70%);
          filter: blur(55px);
          animation: float6 23s ease-in-out infinite;
        }

        .blob-7 {
          width: 320px;
          height: 320px;
          left: 25%;
          top: 80%;
          background: radial-gradient(circle, rgba(185, 28, 28, 0.4) 0%, transparent 70%);
          filter: blur(50px);
          animation: float7 19s ease-in-out infinite;
        }

        .blob-8 {
          width: 150px;
          height: 150px;
          left: 75%;
          top: 25%;
          background: radial-gradient(circle, rgba(153, 27, 27, 0.55) 0%, transparent 70%);
          filter: blur(35px);
          animation: float8 15s ease-in-out infinite;
        }

        .blob-9 {
          width: 120px;
          height: 120px;
          left: 15%;
          top: 35%;
          background: radial-gradient(circle, rgba(124, 58, 237, 0.4) 0%, transparent 70%);
          filter: blur(30px);
          animation: float9 17s ease-in-out infinite;
        }

        .blob-10 {
          width: 100px;
          height: 100px;
          right: 25%;
          top: 55%;
          background: radial-gradient(circle, rgba(185, 28, 28, 0.5) 0%, transparent 70%);
          filter: blur(25px);
          animation: float10 14s ease-in-out infinite;
        }

        .blob-11 {
          width: 60px;
          height: 60px;
          left: 50%;
          top: 15%;
          background: radial-gradient(circle, rgba(153, 27, 27, 0.6) 0%, transparent 70%);
          filter: blur(20px);
          animation: float11 12s ease-in-out infinite;
        }

        .blob-12 {
          width: 80px;
          height: 80px;
          left: 85%;
          top: 85%;
          background: radial-gradient(circle, rgba(139, 92, 246, 0.5) 0%, transparent 70%);
          filter: blur(22px);
          animation: float12 16s ease-in-out infinite;
        }

        @keyframes float1 { 0%, 100% { transform: translate(0, 0); } 25% { transform: translate(60px, 40px); } 50% { transform: translate(30px, 80px); } 75% { transform: translate(-40px, 50px); } }
        @keyframes float2 { 0%, 100% { transform: translate(0, 0); } 25% { transform: translate(-50px, 60px); } 50% { transform: translate(-80px, 20px); } 75% { transform: translate(-30px, -40px); } }
        @keyframes float3 { 0%, 100% { transform: translate(0, 0); } 33% { transform: translate(70px, -50px); } 66% { transform: translate(-40px, 60px); } }
        @keyframes float4 { 0%, 100% { transform: translate(0, 0); } 25% { transform: translate(80px, -30px); } 50% { transform: translate(50px, 70px); } 75% { transform: translate(-20px, 40px); } }
        @keyframes float5 { 0%, 100% { transform: translate(0, 0); } 50% { transform: translate(100px, 60px); } }
        @keyframes float6 { 0%, 100% { transform: translate(0, 0); } 33% { transform: translate(-60px, -80px); } 66% { transform: translate(50px, -40px); } }
        @keyframes float7 { 0%, 100% { transform: translate(0, 0); } 25% { transform: translate(-70px, -50px); } 50% { transform: translate(40px, -80px); } 75% { transform: translate(80px, -20px); } }
        @keyframes float8 { 0%, 100% { transform: translate(0, 0); } 50% { transform: translate(-90px, 70px); } }
        @keyframes float9 { 0%, 100% { transform: translate(0, 0); } 33% { transform: translate(80px, 50px); } 66% { transform: translate(40px, -60px); } }
        @keyframes float10 { 0%, 100% { transform: translate(0, 0); } 25% { transform: translate(60px, -70px); } 50% { transform: translate(-50px, -40px); } 75% { transform: translate(-80px, 30px); } }
        @keyframes float11 { 0%, 100% { transform: translate(0, 0); } 50% { transform: translate(70px, 90px); } }
        @keyframes float12 { 0%, 100% { transform: translate(0, 0); } 33% { transform: translate(-100px, -60px); } 66% { transform: translate(-50px, 40px); } }

        @keyframes bounce { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(10px); } }
        @keyframes gradientShift { 0%, 100% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } }
        @keyframes fadeInUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
        
        @keyframes superSpin {
          0% { transform: scale(1) rotate(0deg); filter: blur(0px); }
          10% { transform: scale(1.1) rotate(360deg); filter: blur(2px); }
          20% { transform: scale(1.15) rotate(720deg); filter: blur(3px); }
          30% { transform: scale(1.2) rotate(1080deg); filter: blur(3px); }
          40% { transform: scale(1.2) rotate(1440deg); filter: blur(3px); }
          50% { transform: scale(1.2) rotate(1800deg); filter: blur(3px); }
          60% { transform: scale(1.2) rotate(2160deg); filter: blur(3px); }
          70% { transform: scale(1.15) rotate(2520deg); filter: blur(2px); }
          80% { transform: scale(1.15) rotate(2880deg); filter: blur(1px); }
          90% { transform: scale(1.1) rotate(3240deg); filter: blur(0px); }
          100% { transform: scale(1) rotate(3600deg); filter: blur(0px); }
        }

        @keyframes logoFloat {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }

        .hero-section { position: relative; min-height: 100vh; display: flex; align-items: flex-start; justify-content: center; padding: 15vh 24px 0 24px; z-index: 1; }
        .hero-content { position: relative; z-index: 10; text-align: center; max-width: 900px; width: 100%; animation: fadeInUp 1s ease-out; display: flex; flex-direction: column; align-items: center; }
        
        .hero-logo-img { 
          width: 300px; 
          height: 300px; 
          object-fit: contain; 
          margin-bottom: -70px; 
          cursor: pointer;
          transition: transform 0.3s ease;
        }
        
        .hero-logo-img.spinning {
          animation: superSpin 0.3s ease-out forwards;
        }
        
        .hero-name { font-family: 'Inter', sans-serif; font-size: clamp(32px, 6vw, 52px); font-weight: 700; letter-spacing: 0.15em; color: rgba(255,255,255,0.95); margin-bottom: 8px; }
        .hero-subtitle { font-family: 'Playfair Display', serif; font-size: clamp(20px, 3vw, 28px); font-weight: 400; font-style: italic; margin-bottom: 32px; }
        .title-gradient { background: linear-gradient(135deg, #991B1B, #B8860B, #991B1B); background-size: 200% 200%; -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; animation: gradientShift 8s ease infinite; }
        .hero-divider { width: 60px; height: 1px; background: linear-gradient(to right, transparent, #991B1B, #B8860B, transparent); margin-bottom: 32px; }
        .hero-headline { font-size: clamp(18px, 2.5vw, 24px); font-weight: 300; line-height: 1.6; margin-bottom: 16px; color: rgba(255,255,255,0.7); }
        .headline-emphasis { color: rgba(255,255,255,0.95); font-weight: 500; }
        .hero-text { font-size: clamp(14px, 1.8vw, 17px); color: rgba(255,255,255,0.45); font-weight: 300; max-width: 450px; margin-bottom: 40px; line-height: 1.6; }
        .hero-buttons { display: flex; gap: 16px; align-items: center; justify-content: center; }
        .scroll-indicator { position: absolute; bottom: 32px; left: 50%; transform: translateX(-50%); animation: bounce 2s ease-in-out infinite; z-index: 10; }
        .arrow-icon { width: 20px; height: 20px; color: rgba(255,255,255,0.3); }

        .section { padding: 80px 24px; position: relative; z-index: 1; }
        .container { max-width: 1100px; margin: 0 auto; }
        .section-header { text-align: center; margin-bottom: 48px; }
        .grid-2col-about { display: grid; grid-template-columns: 1fr 320px; gap: 60px; align-items: center; }
        .grid-3col { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
        .grid-mobile { display: grid; grid-template-columns: 1fr; gap: 24px; }

        .label { color: #991B1B; font-size: 13px; letter-spacing: 0.25em; text-transform: uppercase; margin-bottom: 12px; display: block; font-weight: 500; }
        .heading { font-family: 'Playfair Display', serif; font-size: clamp(28px, 4vw, 42px); font-weight: 400; margin-bottom: 24px; line-height: 1.2; }
        .gradient-text { background: linear-gradient(135deg, #991B1B, #B8860B); background-size: 200% 200%; -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; animation: gradientShift 5s ease infinite; }
        .text-body { color: rgba(255,255,255,0.5); font-size: 15px; line-height: 1.7; margin-bottom: 16px; }

        .btn-primary { padding: 16px 36px; border-radius: 9999px; transition: all 0.3s ease; font-weight: 500; letter-spacing: 0.05em; cursor: pointer; font-family: inherit; font-size: 15px; background: linear-gradient(to right, #991B1B, #7F1D1D); color: white; border: none; }
        .btn-primary:hover { transform: translateY(-3px) scale(1.05); box-shadow: 0 15px 50px rgba(153,27,27,0.5); }

        /* Client Logos */
        .clients-section { padding-top: 60px; padding-bottom: 40px; }
        
        .clients-floating {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          gap: 40px 60px;
          max-width: 900px;
          margin: 0 auto 60px auto;
        }
        
        .floating-logo {
          height: 40px;
          width: auto;
          max-width: 150px;
          object-fit: contain;
          opacity: 0.5;
          transition: all 0.4s ease;
          animation: logoFloat 4s ease-in-out infinite;
        }
        
        .floating-logo:nth-child(odd) { animation-duration: 3.5s; }
        .floating-logo:nth-child(3n) { animation-duration: 4.5s; }
        .floating-logo:hover { opacity: 1; transform: scale(1.15); }

        /* Work Photos Collage */
        .work-collage {
          position: relative;
          height: 400px;
          max-width: 800px;
          margin: 0 auto;
        }

        .photos-collage {
          margin-bottom: 0px;
        }

        .video-collage {
          margin-bottom: 0px;
        }

        .collage-photo {
          position: absolute;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 10px 40px rgba(0,0,0,0.4);
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          cursor: pointer;
        }

        .collage-photo img,
        .collage-photo video {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .collage-photo:hover {
          transform: scale(1.08) rotate(0deg) !important;
          z-index: 10;
          box-shadow: 0 20px 60px rgba(153,27,27,0.3);
        }

        /* Expanded state - Apple-style grow */
        .collage-photo.expanded {
          transform: scale(1.8) rotate(0deg) translateY(-40px) !important;
          z-index: 100;
          box-shadow: 0 40px 100px rgba(0,0,0,0.6);
        }

        .collage-photo.expanded:hover {
          transform: scale(1.8) rotate(0deg) translateY(-40px) !important;
        }

        /* Photo positions */
  /* Photo positions - 3 photos, closer together */
.collage-photo-1 {
  width: 160px;
  height: 210px;
  left: 15%;
  top: 10%;
  transform: rotate(-5deg);
  z-index: 2;
}

.collage-photo-2 {
  width: 180px;
  height: 240px;
  left: 38%;
  top: 5%;
  transform: rotate(3deg);
  z-index: 3;
}

.collage-photo-3 {
  width: 150px;
  height: 200px;
  right: 15%;
  top: 15%;
  transform: rotate(-4deg);
  z-index: 1;
}

.collage-photo-4 {
  display: none;
}
        .collage-video-1 {
          width: 160px;
          height: 220px;
          left: 8%;
          top: 15%;
          transform: rotate(5deg);
          z-index: 2;
        }

        .collage-video-2 {
          width: 140px;
          height: 190px;
          left: 28%;
          top: 5%;
          transform: rotate(-4deg);
          z-index: 3;
        }

        .collage-video-3 {
          width: 180px;
          height: 240px;
          left: 42%;
          top: 20%;
          transform: rotate(3deg);
          z-index: 1;
        }

        .collage-video-4 {
          width: 150px;
          height: 200px;
          right: 22%;
          top: 8%;
          transform: rotate(-6deg);
          z-index: 4;
        }

        .collage-video-5 {
          width: 170px;
          height: 230px;
          right: 3%;
          top: 25%;
          transform: rotate(4deg);
          z-index: 2;
        }
.hero-logo-img { 
  width: 150px; 
  height: 300px; 
  ...
}@media (max-width: 768px) {
  ...
  .hero-logo-img { 
    width: 150px;        /* ← HIER ändern */
    height: 150px;       /* ← HIER ändern */
    margin-bottom: 30px; 
  }
  ...
}

        .profile-wrapper { position: relative; }
        .profile-card { aspect-ratio: 3/4; border-radius: 12px; background: linear-gradient(135deg, #1A1A1A, #0A0A0A); border: 1px solid rgba(255,255,255,0.08); overflow: hidden; transition: all 0.4s ease; }
        .profile-card:hover { border-color: rgba(153,27,27,0.4); box-shadow: 0 20px 60px rgba(153,27,27,0.2); }
        .profile-border { position: absolute; bottom: -10px; right: -10px; width: 100%; height: 100%; border: 1px solid rgba(153,27,27,0.3); border-radius: 12px; z-index: -1; }

        .video-wrapper { max-width: 850px; margin: 0 auto; }
        .video-card { aspect-ratio: 16/9; border-radius: 12px; background: linear-gradient(135deg, #1A1A1A, #0A0A0A); border: 1px solid rgba(255,255,255,0.08); overflow: hidden; position: relative; transition: all 0.4s ease; }
        .video-card:hover { border-color: rgba(153,27,27,0.4); box-shadow: 0 20px 60px rgba(153,27,27,0.25); }
        .video-placeholder { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; flex-direction: column; gap: 12px; }
        .play-button { width: 70px; height: 70px; border-radius: 50%; background: rgba(153,27,27,0.15); display: flex; align-items: center; justify-content: center; border: 1px solid rgba(153,27,27,0.4); transition: all 0.3s ease; }
        .play-button:hover { background: rgba(153,27,27,0.3); transform: scale(1.1); }
        .play-icon { width: 28px; height: 28px; color: #991B1B; margin-left: 4px; }
        .placeholder-text { color: rgba(255,255,255,0.3); font-size: 13px; }

        .services-layout { display: grid; grid-template-columns: 1fr 240px; gap: 40px; align-items: start; }
        .services-layout-mobile { display: flex; flex-direction: column; gap: 32px; }
        .services-grid { display: flex; flex-direction: column; gap: 16px; }
        .service-card { padding: 20px 24px; border-radius: 12px; background: rgba(26,26,26,0.5); border: 1px solid rgba(255,255,255,0.08); transition: all 0.4s ease; display: flex; align-items: flex-start; gap: 16px; backdrop-filter: blur(10px); }
        .service-card:hover { transform: translateX(8px); border-color: rgba(153,27,27,0.4); background: rgba(26,26,26,0.8); box-shadow: 0 10px 40px rgba(153,27,27,0.15); }
        .service-icon { width: 44px; height: 44px; min-width: 44px; border-radius: 10px; background: linear-gradient(135deg, rgba(153,27,27,0.15), rgba(184,134,11,0.1)); display: flex; align-items: center; justify-content: center; transition: all 0.3s ease; }
        .service-card:hover .service-icon { background: linear-gradient(135deg, rgba(153,27,27,0.3), rgba(184,134,11,0.2)); transform: scale(1.1); }
        .service-content { flex: 1; }
        .service-title { font-family: 'Playfair Display', serif; font-size: 18px; font-weight: 500; margin-bottom: 6px; transition: color 0.3s ease; }
        .service-card:hover .service-title { color: #B8860B; }
        .service-desc { color: rgba(255,255,255,0.5); font-size: 14px; line-height: 1.5; margin: 0; }

        .tech-video-container { position: sticky; top: 80px; }
        .tech-video-card { aspect-ratio: 9/16; max-height: 420px; border-radius: 12px; background: linear-gradient(135deg, #1A1A1A, #0A0A0A); border: 1px solid rgba(255,255,255,0.08); overflow: hidden; position: relative; transition: all 0.4s ease; }
        .tech-video-card:hover { border-color: rgba(153,27,27,0.4); box-shadow: 0 15px 50px rgba(153,27,27,0.2); }

        .contact-card { display: flex; flex-direction: column; align-items: center; padding: 28px; border-radius: 12px; background: rgba(26,26,26,0.4); border: 1px solid rgba(255,255,255,0.08); text-decoration: none; transition: all 0.4s ease; cursor: pointer; backdrop-filter: blur(10px); }
        .contact-card:hover { transform: translateY(-6px); border-color: rgba(153,27,27,0.5); background: rgba(26,26,26,0.7); box-shadow: 0 15px 50px rgba(153,27,27,0.2); }
        .contact-icon { width: 50px; height: 50px; border-radius: 50%; background: linear-gradient(135deg, rgba(153,27,27,0.15), rgba(184,134,11,0.1)); display: flex; align-items: center; justify-content: center; margin-bottom: 12px; transition: all 0.3s ease; }
        .contact-card:hover .contact-icon { background: linear-gradient(135deg, rgba(153,27,27,0.3), rgba(184,134,11,0.2)); transform: scale(1.1); }
        .contact-label { color: rgba(255,255,255,0.8); font-weight: 500; font-size: 14px; }
        .contact-value { color: rgba(255,255,255,0.4); font-size: 13px; margin-top: 4px; }

        .social-links { display: flex; justify-content: center; gap: 20px; margin-top: 48px; }
        .social-link { width: 44px; height: 44px; border-radius: 50%; border: 1px solid rgba(255,255,255,0.1); display: flex; align-items: center; justify-content: center; color: rgba(255,255,255,0.5); text-decoration: none; transition: all 0.3s ease; background: rgba(26,26,26,0.3); }
        .social-link:hover { border-color: rgba(153,27,27,0.6); color: #991B1B; transform: translateY(-4px) scale(1.1); background: rgba(153,27,27,0.1); }

        .footer { padding: 40px 24px; border-top: 1px solid rgba(255,255,255,0.05); position: relative; z-index: 1; }
        .footer-content { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 20px; }
        .footer-text { color: rgba(255,255,255,0.3); font-size: 13px; }
        .footer-links { display: flex; gap: 28px; }
        .footer-link { color: rgba(255,255,255,0.3); text-decoration: none; transition: color 0.3s ease; font-size: 13px; background: none; border: none; cursor: pointer; font-family: inherit; }
        .footer-link:hover { color: #991B1B; }

        .modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.9); backdrop-filter: blur(10px); display: flex; align-items: center; justify-content: center; z-index: 1000; padding: 20px; }
        .modal-content { background: linear-gradient(135deg, #1A1A1A, #0D0D0D); border: 1px solid rgba(255,255,255,0.1); border-radius: 12px; max-width: 600px; width: 100%; max-height: 85vh; overflow-y: auto; padding: 36px; position: relative; }
        .modal-close { position: absolute; top: 16px; right: 16px; background: rgba(153,27,27,0.2); border: 1px solid rgba(153,27,27,0.4); color: #991B1B; font-size: 24px; width: 36px; height: 36px; border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all 0.3s ease; line-height: 1; }
        .modal-close:hover { background: rgba(153,27,27,0.4); transform: scale(1.1); }
        .modal-title { font-family: 'Playfair Display', serif; font-size: 28px; font-weight: 400; margin-bottom: 24px; background: linear-gradient(135deg, #991B1B, #B8860B); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
        .modal-body { color: rgba(255,255,255,0.8); line-height: 1.7; }
        .modal-body h3 { font-family: 'Playfair Display', serif; color: rgba(255,255,255,0.9); font-size: 18px; font-weight: 500; margin-top: 24px; margin-bottom: 10px; }
        .modal-body h3:first-child { margin-top: 0; }
        .modal-body p { color: rgba(255,255,255,0.55); font-size: 14px; margin-bottom: 10px; }

        @media (max-width: 768px) {
          .section { padding: 60px 20px; }
          .hero-section { padding: 15vh 20px 0 20px; }
          .section-header { margin-bottom: 36px; }
          .btn-primary { width: 100%; max-width: 260px; }
          .footer-content { flex-direction: column; text-align: center; }
          .modal-content { padding: 24px 18px; }
          .hero-logo-img { width: 150px; height: 150px; margin-bottom: -30px; }
          .hero-name { letter-spacing: 0.1em; }
          .grid-2col-about { grid-template-columns: 1fr; gap: 36px; }
          .profile-wrapper { max-width: 280px; margin: 0 auto; }
          .service-card { flex-direction: column; text-align: center; }
          .service-icon { margin: 0 auto; }
          .tech-video-container { order: -1; }
          .tech-video-card { max-height: 360px; max-width: 200px; margin: 0 auto; }
          .blob { transform: scale(0.6); }
          .clients-floating { gap: 30px 40px; }
          .floating-logo { height: 30px; }
          
          .work-collage { height: 300px; }
          .photos-collage { margin-bottom: -100px; }
          .video-collage { margin-bottom: -200px; }
          
         .collage-photo-1 { width: 100px; height: 130px; left: 10%; top: 5%; }
.collage-photo-2 { width: 120px; height: 160px; left: 35%; top: 0; }
.collage-photo-3 { width: 100px; height: 130px; right: 10%; top: 10%; }
.collage-photo-4 { display: none; }

.collage-video-1 { width: 90px; height: 120px; left: 5%; top: 5%; }
.collage-video-2 { width: 100px; height: 135px; left: 25%; top: 15%; }
.collage-video-3 { width: 110px; height: 145px; left: 50%; transform: translateX(-50%) rotate(3deg); top: 0; }
.collage-video-4 { width: 95px; height: 125px; right: 25%; top: 20%; }
.collage-video-5 { width: 90px; height: 120px; right: 5%; top: 8%; }
        }
      `}</style>
    </div>
  );
}
